import { getAuthenticatedRequestInit } from './utils';
import { getApiHost } from '../utils/hosts';
import logger from '../utils/logger-rum';

export interface PhoneUserIdentity {
	gr_user?: number;
	email?: string;
	first_name?: string;
	last_name?: string;
	poster?: string;
}

export async function SendDtmf(token: string, meetingId: string, sipConnectionId: string, digits: string) {
	const url = `${getApiHost()}/v2/greenroom/dial-phone/${meetingId}/${sipConnectionId}/dtmf`;
	try {
		const res = await fetch(url, {
			method: 'POST',
			body: JSON.stringify({ digits }),
			...getAuthenticatedRequestInit(token),
		});
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		return { ok: false, message: text };
	} catch (e) {
		return { ok: false, message: 'Connection Error' };
	}
}

export async function HangupPhoneByUser(token: string, meetingId: string, grUser: number | string) {
	const url = `${getApiHost()}/v2/greenroom/dial-phone/${meetingId}/by-user/${grUser}`;
	try {
		const res = await fetch(url, { method: 'DELETE', ...getAuthenticatedRequestInit(token) });
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		return { ok: false, message: text };
	} catch (e) {
		return { ok: false, message: 'Connection Error' };
	}
}

export async function HangupAllPhones(token: string, meetingId: string) {
	const url = `${getApiHost()}/v2/greenroom/dial-phone/${meetingId}/all`;
	try {
		const res = await fetch(url, { method: 'DELETE', ...getAuthenticatedRequestInit(token) });
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		return { ok: false, message: text };
	} catch (e) {
		return { ok: false, message: 'Connection Error' };
	}
}

export async function HangupPhone(token: string, meetingId: string, sipConnectionId: string) {
	const url = `${getApiHost()}/v2/greenroom/dial-phone/${meetingId}/${sipConnectionId}`;
	try {
		const res = await fetch(url, {
			method: 'DELETE',
			...getAuthenticatedRequestInit(token),
		});
		if (res.ok || res.status === 204) return { ok: true };
		const text = await res.text();
		logger.error('[HangupPhone] error response', res.status, text);
		return { ok: false, message: text };
	} catch (e) {
		logger.error('[HangupPhone] fetch error', e);
		return { ok: false, message: 'Connection Error' };
	}
}

export default async function DialPhone(
	token: string,
	phoneNumber: string,
	meetingId: string,
	userIdentity?: PhoneUserIdentity,
) {
	const url = `${getApiHost()}/v2/greenroom/dial-phone/${meetingId}`;
	console.log('[DialPhone] calling', url, { phoneNumber, userIdentity, hasToken: !!token, meetingId });
	try {
		const res = await fetch(url, {
			method: 'POST',
			body: JSON.stringify({ phoneNumber, userIdentity }),
			...getAuthenticatedRequestInit(token),
		});
		console.log('[DialPhone] response status', res.status);
		if (res.ok) return res.json();
		const text = await res.text();
		logger.error('[DialPhone] error response', res.status, text);
		return { message: `Response Error (${res.status}): ${text}` };
	} catch (e) {
		logger.error('[DialPhone] fetch error', e);
		return { message: 'Connection Error' };
	}
}
